import React, { ChangeEvent } from 'react';
import { TFunction } from 'react-i18next';
import {
  IBusinessBoxFieldsSettings,
  TBusinessBoxFormikProps,
} from '../BusinessBoxCreate/types';
import { FormLabel, Input } from '@infologistics/frontend-libraries';
import { getErrorText, hasError } from '@app/utils/utils';

export const BusinessBoxInput = <T,>(
  val: IBusinessBoxFieldsSettings,
  formikProps: TBusinessBoxFormikProps<T>,
  t: TFunction
) => {
  const {
    fieldName,
    wrapperClasses,
    itemClasses,
    label,
    required,
    labelClasses,
  } = val;
  const { values, setFieldValue, errors, touched, setFieldTouched } =
    formikProps;
  const value = values[fieldName];

  const handleTextFieldChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;

    setFieldTouched(name);
    setFieldValue(name, value || null);
  };

  return (
    <div className={wrapperClasses} key={fieldName}>
      <FormLabel htmlFor={fieldName} classes={labelClasses ?? 'grid-item-2'}>
        {t(label)}
        {required && <span className='text-danger'> *</span>}
      </FormLabel>
      <Input
        id={fieldName}
        name={fieldName}
        type={'string'}
        value={value}
        classes={itemClasses}
        onChange={handleTextFieldChange}
        disabled={false}
        hasError={hasError(fieldName, errors, touched)}
        errorText={t(getErrorText(fieldName, errors))}
      />
    </div>
  );
};
